var _defs, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChrmpLogoTagline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 445.96 237.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:149.29px;}.cls-1,.cls-3,.cls-4{fill:#2960a1;}.cls-1,.cls-3{font-family:Nexa-Bold, Nexa;font-weight:700;}.cls-2{fill:#8dc162;}.cls-3{font-size:29.36px;}.cls-4{font-size:30px;font-family:Calibri;}.cls-5{letter-spacing:-0.01em;}.cls-6{letter-spacing:-0.01em;}.cls-7{letter-spacing:-0.01em;}.cls-8{letter-spacing:0em;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 126.89) scale(0.92 1)"
  }, "c", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 75.99,
    y: 0
  }, "hr"), /*#__PURE__*/React.createElement("tspan", {
    x: 231.09,
    y: 0
  }, "mp"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(421.14 46.23) scale(1.03 1)"
  }, "\xAE")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(14.83 192.1) scale(1.06 1)"
  }, "CE", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 30.64,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.64,
    y: 0
  }, "TIFIED HUMAN R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 253.43,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 267.79,
    y: 0
  }, "SOU"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 320.68,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 336.71,
    y: 0
  }, "CE "), /*#__PURE__*/React.createElement("tspan", {
    x: -1.92,
    y: 36
  }, "MAN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 60.45,
    y: 36
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 77.59,
    y: 36
  }, "GEMENT P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 207.73,
    y: 36
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 223.73,
    y: 36
  }, "OF"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 257.37,
    y: 36
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 271.73,
    y: 36
  }, "SSIONAL"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrmpLogoTagline);
export default __webpack_public_path__ + "static/media/CHRMP Logo - Tagline.70939cd502fa015ccc8ec155109d7926.svg";
export { ForwardRef as ReactComponent };